import FormReleasedService, {
  CertificateForm,
} from 'front-office/components/released-services/form';
import { transformCertificate } from 'front-office/components/released-services/utils/transform-certificate';
import { Fragment } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ReleasedService } from 'shell/models/certificate';
import { HttpResponse } from 'shell/models/http-response';
import { noop } from 'shell/utils/noop';
import { CommonCertificateCrumbs } from '../constants';

const ReleasedServiceDetailPage = (): React.ReactElement => {
  const params = useParams();

  const navigate = useNavigate();

  const [certificate] = useHttpFetch<HttpResponse<ReleasedService>, CertificateForm>(
    `${__CERTIFICATION_API_URL__}/certificazione/registro-doc-rilasciati/${params.idSigla}/${params.idAnno}/${params.progressivo}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformCertificate,
    }
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonCertificateCrumbs, { name: 'Dettaglio Certificato' }]} />
      {certificate.isLoading || !certificate.data ? null : (
        <FormReleasedService
          title={'Dettaglio Servizio rilasciato'}
          onOk={noop}
          isView
          onGoBack={() => {
            navigate('/sportello/controllo-di-cassa');
          }}
          disabled
          initialValues={certificate.data as CertificateForm}
        />
      )}
    </Fragment>
  );
};

ReleasedServiceDetailPage.displayName = 'Released Service Detail page component';

export default ReleasedServiceDetailPage;
